import { render, staticRenderFns } from "./MaterialsSelectorDialog.vue?vue&type=template&id=311fa1f1&scoped=true"
import script from "./MaterialsSelectorDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsSelectorDialog.vue?vue&type=style&index=0&id=311fa1f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fa1f1",
  null
  
)

export default component.exports